import * as React from 'react';

import {FileUploadModalPage} from 'shells/form/file-upload-modal-page';
import {Link} from 'shells/link/link';
import {Modal} from 'shells/modal/modal';
import {MarketingBody} from 'shells/typography/marketing-body';

import {Home} from './pages';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export type Page = 'home' | 'csv' | 'mailchimp' | 'ctct';

export function UnsubscribeModal(props: Props) {
    const [page, setPage] = React.useState<Page>('home');

    return (
        <Modal
            headerBackButton={page !== 'home'}
            onHeaderBackButtonPress={() => {
                setPage('home');
            }}
            headerText={getTitleTextForPage(page)}
            isOpen={props.isOpen}
            onClose={props.onClose}
            minHeight={636}
            maxHeight={636}
        >
            {page === 'home' ? <Home onSelectImportType={(type) => setPage(type)} /> : undefined}
            {['csv', 'mailchimp', 'ctct'].includes(page) ? (
                <FileUploadModalPage subheaderText={getSubheaderText(page)} isUnsubscribe={true} />
            ) : undefined}
        </Modal>
    );
}

function getSubheaderText(page: string) {
    switch (page) {
        case 'csv':
            return (
                <MarketingBody>
                    Once you upload your file, we’ll walk you through mapping your data to the right
                    places in Nutshell.
                </MarketingBody>
            );
        case 'mailchimp':
            return (
                <>
                    <MarketingBody>
                        Need some help getting your data into a CSV file?{' '}
                        <Link
                            href='https://support.nutshell.com/en/articles/8428874-audiences-unsubscribe-contacts-from-campaigns'
                            size='big'
                            variant='primary'
                            newTab={true}
                        >
                            Learn how to export from MailChimp
                        </Link>
                    </MarketingBody>
                    <MarketingBody>
                        Once you’ve got that file exported, upload it here and we’ll walk you
                        through mapping your data to the right places in Nutshell.
                    </MarketingBody>
                </>
            );
        case 'ctct':
            return (
                <>
                    <MarketingBody>
                        Need some help getting your data into a CSV file?{' '}
                        <Link
                            href='https://support.nutshell.com/en/articles/8428874-audiences-unsubscribe-contacts-from-campaigns'
                            size='big'
                            variant='primary'
                            newTab={true}
                        >
                            Learn how to export from Constant Contact
                        </Link>
                    </MarketingBody>
                    <MarketingBody>
                        Once you’ve got that file exported, upload it here and we’ll walk you
                        through mapping your data to the right places in Nutshell.
                    </MarketingBody>
                </>
            );
        default:
            return (
                <MarketingBody>
                    Once you upload your file, we’ll walk you through mapping your data to the right
                    places in Nutshell.
                </MarketingBody>
            );
    }
}

function getTitleTextForPage(page: string) {
    switch (page) {
        case 'home':
            return 'Where is your unsubscribe data coming from?';
        case 'csv':
            return 'Upload your spreadsheet to get started';
        case 'mailchimp':
            return 'Export your unsubscribe data from MailChimp';
        case 'ctct':
            return 'Export your unsubscribe data from Constant Contact';
        default:
            return 'This shouldn’t happen';
    }
}
